import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useLocation, Link, useNavigate, useParams } from "react-router-dom";
import { AthleteTabMenu } from "./AthleteTabMenu";
import SingleSelectExerciseList from "../component/SingleSelectExerciseList";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import AthleteProfileCard from "../component/AthleteProfileCard";
import {
  MdAdd,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { RiDeleteBin4Line } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";

// Helper to format a date nicely
/*const getFormattedDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};*/

const DotedSvg = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const SaveTempIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.3337 13.9993V9.33268C11.3337 9.15587 11.2634 8.9863 11.1384 8.86128C11.0134 8.73625 10.8438 8.66602 10.667 8.66602H5.33366C5.15685 8.66602 4.98728 8.73625 4.86225 8.86128C4.73723 8.9863 4.66699 9.15587 4.66699 9.33268V13.9993"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.66699 2V4.66667C4.66699 4.84348 4.73723 5.01305 4.86225 5.13807C4.98728 5.2631 5.15685 5.33333 5.33366 5.33333H10.0003"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const getFormattedDate = (dateStr) => {
  if (!dateStr) return "Invalid Date";

  // Try to parse YYYY-MM-DD format
  const parts = String(dateStr).split("-");
  if (parts.length === 3) {
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]);
    const day = parseInt(parts[2]);

    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      });
    }
  }

  // Fallback
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};

export const AdminAthleteSpeedWorkout = () => {
  const { staff } = useStaffAuthContext();
  const { athlete_id } = useParams();
  const navigate = useNavigate();

  const [athlete, setAthlete] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [weeks, setWeeks] = useState([]);
  const [selectedDayInfo, setSelectedDayInfo] = useState(null);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [newWeekStartDate, setNewWeekStartDate] = useState("");

  const [activeWeekTab, setActiveWeekTab] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");

  // Store month as "YYYY-MM" string to prevent offset bugs
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 7); // "YYYY-MM"
  });

  const fetchAthleteData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API_URL.GET_ATHLETE_BY_ID}/${athlete_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        },
      );
      const data = await response.json();
      if (response.ok) {
        setAthlete(data);
      } else {
        setError(data.error || "Failed to load athlete data.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAthleteData();
  }, [athlete_id, staff.token]);

  useEffect(() => {
    const fetchWeeks = async () => {
      if (!athlete_id || !selectedMonth) return;

      try {
        const response = await fetch(
          `${API_URL.GET_ATHLETE_SPEEDWORKOUT_WEEKS}?athlete_id=${athlete_id}&month=${selectedMonth}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${staff.token}`,
            },
          },
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Failed to fetch week data.");
        }

        // Normalize week data: ensure `startDate` and `days`
        const formattedWeeks = data.data.map((week) => ({
          startDate: week.week_start_date,
          days: week.days,
        }));

        setWeeks(formattedWeeks);
      } catch (error) {
        console.error("Error fetching weeks:", error);
        setError(error.message || "Something went wrong while loading weeks.");
      }
    };

    fetchWeeks();
  }, [athlete_id, selectedMonth, staff.token]);

  const handleAddWeek = () => {
    setShowDatePicker(true);
  };

  const handleCloseWeek = () => {
    setShowDatePicker(false);
  };

  const handleSaveNewWeek = async () => {
    if (!newWeekStartDate) return;

    const [year, month, day] = newWeekStartDate.split("-").map(Number);
    const start = new Date(year, month - 1, day);

    // Check if the selected date is a Sunday (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    if (start.getDay() !== 0) {
      alert(
        "❌ The selected date is not a Sunday. Please select a Sunday to start the week.",
      );
      return;
    }

    const days = Array.from({ length: 7 }, (_, i) => {
      const date = new Date(start);
      date.setDate(start.getDate() + i);

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const localDateString = `${yyyy}-${mm}-${dd}`;

      return {
        label: date.toLocaleDateString("en-US", { weekday: "short" }),
        date: localDateString,
      };
    });

    try {
      const response = await fetch(API_URL.SAVE_ATHLETE_SPEEDWORKOUT_WEEK, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({
          athlete_id,
          week_start_date: newWeekStartDate, // in YYYY-MM-DD format
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to save week.");
      }

      setWeeks((prev) => [...prev, { startDate: newWeekStartDate, days }]);
      setShowDatePicker(false);
      setNewWeekStartDate("");
      //setNewWeekStartDateDisplay(""); // Clear text input
      setSuccessMessage("✅ New week added successfully!");
    } catch (error) {
      console.error("Error saving week:", error);
      alert(error.message || "Something went wrong while saving.");
    }
  };

  const handleDeleteWeek = async (weekStartDate) => {
    if (!window.confirm("Are you sure you want to delete this week?")) return;

    try {
      const response = await fetch(API_URL.DELETE_ATHLETE_SPEEDWORKOUT_WEEK, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({
          athlete_id,
          week_start_date: weekStartDate,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to delete week.");
      }

      setWeeks((prev) =>
        prev.filter((week) => week.startDate !== weekStartDate),
      );
      setSuccessMessage("🗑️ Week deleted successfully!");
    } catch (error) {
      console.error("Error deleting week:", error);
      alert(error.message || "Something went wrong while deleting.");
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(""); // Clear message after 3 seconds
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleDaySelect = (weekIdx, dayIdx) => {
    const selected = weeks[weekIdx].days[dayIdx];
    setSelectedDayInfo({ weekIdx, dayIdx, ...selected });
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value); // "YYYY-MM"
  };

  const filteredWeeks = weeks.filter((week) => {
    const weekMonth = new Date(week.startDate).toISOString().slice(0, 7); // "YYYY-MM"
    return weekMonth === selectedMonth;
  });

  useEffect(() => {
    setActiveWeekTab(0);
  }, [filteredWeeks.length]);

  //training focus logic related
  //TRAINING FOCUS LETS LOAD ALL FROM THE MASTER
  const [trainingFocuses, setTrainingFocuses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedId, setExpandedId] = useState(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [focusToApply, setFocusToApply] = useState(null);
  const [reorderMode, setReorderMode] = useState(false);

  const [openSprintId, setOpenSprintId] = useState(null);

  const toggleSprint = (id) => {
    setOpenSprintId((prev) => (prev === id ? null : id));
  };

  //end of training focus related

  useEffect(() => {
    const fetchTrainingFocuses = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(
          API_URL.ADMIN_SPEED_TEMPLATE_TRAINING_FOCUS_MANAGE,
          {
            headers: {
              Authorization: `Bearer ${staff.token}`,
            },
          },
        );
        const data = await res.json();
        setTrainingFocuses(data.data || []);
        setTotalPages(Math.ceil((data.data || []).length / itemsPerPage));
      } catch (err) {
        setError("Failed to load training focus data.");
      } finally {
        setIsLoading(false);
      }
    };

    if (staff?.token) fetchTrainingFocuses();
  }, [staff.token, currentPage, itemsPerPage]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  };

  const filteredTrainingFocuses = trainingFocuses.filter(
    (item) =>
      item.training_focus.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.training_phase.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  //copy the data from the training focus into the specific day that is selected
  const applyFocusToDay = (focus) => {
    if (!selectedDayInfo) return;

    const { weekIdx, dayIdx } = selectedDayInfo;

    setWeeks((prevWeeks) => {
      const updatedWeeks = [...prevWeeks];

      const targetWeek = { ...updatedWeeks[weekIdx] };
      const updatedDays = [...targetWeek.days];

      const existingDay = { ...updatedDays[dayIdx] };

      // Apply focus to the selected day
      updatedDays[dayIdx] = {
        ...existingDay,
        training_focus: focus.training_focus || "",
        training_phase: focus.training_phase || "",
        sprints: (focus.sprints || []).map((sprint, index) => {
          const newSprint = {
            exercise_id: sprint.exercise_id?._id || sprint.exercise_id,
            order_id: index + 1,
            sets: sprint.sets || 0,
            reps: sprint.reps || 0,
            distance: sprint.distance || 0,
            pace: sprint.pace || 0,
            intensity: sprint.intensity || 0,
            rest: sprint.rest || "",
            notes: sprint.notes || "",
            type: sprint.type || "Sprint",
            rest_duration: sprint.rest_duration || "",
            rest_notes: sprint.rest_notes || "",
          };

          // Calculate target_time for this athlete
          const computed = calculateTargetTime(newSprint, athlete);
          newSprint.target_time = computed ? parseFloat(computed) : null;

          return newSprint;
        }),
      };

      // Update the week with new days array
      updatedWeeks[weekIdx] = {
        ...targetWeek,
        days: updatedDays,
      };

      console.log(updatedWeeks);

      return updatedWeeks;
    });
  };
  const selectedDay =
    weeks[selectedDayInfo?.weekIdx]?.days?.[selectedDayInfo?.dayIdx] || {};

  // Dropdown options
  const distances = [
    20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 133, 134, 150, 180, 200, 220,
    250, 300, 350, 400,
  ];

  const intensities = [75, 80, 85, 88, 90, 92, 95, 98, 100];
  const rests = [
    "30s",
    "1m",
    "2m",
    "3m",
    "4m",
    "5m",
    "6m",
    "7m",
    "8m",
    "9m",
    "10m",
    "12m",
    "15m",
    "18m",
    "20",
    "25",
    "30m",
  ];
  const paces = [100, 200, 400];
  const range = (min, max) =>
    Array.from({ length: max - min + 1 }, (_, i) => i + min);

  const [showRestInput, setShowRestInput] = useState(false);
  const [restNoteInput, setRestNoteInput] = useState("");

  const [exerciseOptions, setExerciseOptions] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(false);
  // Fetch exercise options
  useEffect(() => {
    const fetchExercises = async () => {
      try {
        const res = await fetch(`${API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN}`, {
          headers: {
            Authorization: `Bearer ${staff?.token}`,
          },
        });
        const data = await res.json();
        if (res.ok && data?.exercises) {
          setExerciseOptions(data.exercises);

          //  console.log("Exer Options");
        }
      } catch (err) {
        console.error("Error loading exercises:", err);
      }
    };

    fetchExercises();
  }, [staff?.token]);

  const handleSprintChange = (sprintIndex, field, value) => {
    if (!selectedDayInfo) return;

    const { weekIdx, dayIdx } = selectedDayInfo;

    setWeeks((prevWeeks) => {
      const updatedWeeks = [...prevWeeks];
      const targetWeek = { ...updatedWeeks[weekIdx] };
      const updatedDays = [...targetWeek.days];
      const targetDay = { ...updatedDays[dayIdx] };
      const updatedSprints = [...targetDay.sprints];

      const updatedSprint = { ...updatedSprints[sprintIndex] };

      if (["sets", "reps", "distance", "pace", "intensity"].includes(field)) {
        updatedSprint[field] = parseInt(value) || 0;
      } else {
        updatedSprint[field] = value;
      }

      // 👇 Compute & SAVE target_time
      const computed = calculateTargetTime(updatedSprint, athlete);
      updatedSprint.target_time = computed ? parseFloat(computed) : null;

      updatedSprints[sprintIndex] = updatedSprint;
      targetDay.sprints = updatedSprints;
      updatedDays[dayIdx] = targetDay;
      updatedWeeks[weekIdx] = { ...targetWeek, days: updatedDays };

      return updatedWeeks;
    });
  };

  const deleteSprintRow = (indexToRemove) => {
    if (!selectedDayInfo) return;

    const { weekIdx, dayIdx } = selectedDayInfo;

    setWeeks((prevWeeks) => {
      const updatedWeeks = [...prevWeeks];
      const targetWeek = { ...updatedWeeks[weekIdx] };
      const updatedDays = [...targetWeek.days];
      const targetDay = { ...updatedDays[dayIdx] };

      if (!targetDay.sprints || !Array.isArray(targetDay.sprints))
        return prevWeeks;

      const filteredSprints = targetDay.sprints.filter(
        (_, i) => i !== indexToRemove,
      );

      // Reassign order_id after deletion
      const reindexedSprints = filteredSprints.map((sprint, idx) => ({
        ...sprint,
        order_id: idx + 1,
      }));

      targetDay.sprints = reindexedSprints;
      updatedDays[dayIdx] = targetDay;
      updatedWeeks[weekIdx] = { ...targetWeek, days: updatedDays };

      return updatedWeeks;
    });
  };

  const addSprintRow = () => {
    if (!selectedDayInfo) return;

    const { weekIdx, dayIdx } = selectedDayInfo;

    setWeeks((prevWeeks) => {
      const updatedWeeks = [...prevWeeks];
      const targetWeek = { ...updatedWeeks[weekIdx] };
      const updatedDays = [...targetWeek.days];
      const targetDay = { ...updatedDays[dayIdx] };

      const sprints = targetDay.sprints || [];

      const newSprint = {
        type: "Sprint",
        sets: 1,
        reps: 1,
        distance: 10,
        pace: 100,
        intensity: 75,
        rest: "",
        notes: "",
        target_time: 0,
        rest_duration: "",
        rest_notes: "",
        order_id: sprints.length + 1,
        exercise_id: null,
      };

      targetDay.sprints = [...sprints, newSprint];
      updatedDays[dayIdx] = targetDay;
      updatedWeeks[weekIdx] = { ...targetWeek, days: updatedDays };

      return updatedWeeks;
    });

    // await handleSaveTemplate(); // Uncomment if needed
  };

  const addRestRow = (restNotes = "") => {
    if (!selectedDayInfo) return;

    const { weekIdx, dayIdx } = selectedDayInfo;

    setWeeks((prevWeeks) => {
      const updatedWeeks = [...prevWeeks];
      const targetWeek = { ...updatedWeeks[weekIdx] };
      const updatedDays = [...targetWeek.days];
      const targetDay = { ...updatedDays[dayIdx] };

      const sprints = targetDay.sprints || [];

      const newRestRow = {
        type: "Rest",
        order_id: sprints.length + 1,
        sets: 0, // Required by backend
        reps: 0, // Required by backend
        rest_duration: "",
        rest_notes: restNotes,
      };

      targetDay.sprints = [...sprints, newRestRow];
      updatedDays[dayIdx] = targetDay;
      updatedWeeks[weekIdx] = { ...targetWeek, days: updatedDays };

      return updatedWeeks;
    });

    // await handleSaveTemplate(); // Uncomment if needed
  };

  const handleSaveTemplate = async () => {
    try {
      if (!athlete_id) {
        alert("Athlete ID is missing.");
        return;
      }

      const formattedWeeks = Object.entries(weeks || {}).map(
        ([weekKey, weekData]) => {
          const { days, week_start_date } = weekData;

          return {
            week_start_date,
            days: Object.values(days || {}).map((day) => ({
              date: day.date,
              label: day.label,
              training_focus: day.training_focus || "",
              training_phase: day.training_phase || "",
              sprints: (day.sprints || []).map((sprint, index) => ({
                ...sprint,
                order_id: index + 1,
              })),
            })),
          };
        },
      );

      const response = await fetch(API_URL.SAVE_ATHLETE_SPEEDWORKOUT_DATA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff?.token}`,
        },
        body: JSON.stringify({
          athlete_id,
          weeksData: formattedWeeks, // 👈 this is the correct key
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to save template");
      }

      alert("Template saved successfully!");
      // Optionally refresh data
      // await fetchTemplate();
    } catch (error) {
      console.error("Error saving template:", error);
      alert("Error saving template: " + error.message);
    }
  };

  const handleSprintDragEnd = (event, weekKey, dayKey) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setWeeks((prev) => {
      const newWeeksData = structuredClone(prev);
      const week = newWeeksData?.[weekKey];
      const day = week?.days?.[dayKey];

      if (!day || !Array.isArray(day.sprints)) return prev;

      const sprints = [...day.sprints];

      // Fallback to temp IDs for unsaved sprints
      const getSprintId = (s, index) => s._id || `temp-${index}`;
      const sprintIds = sprints.map(getSprintId);

      const oldIndex = sprintIds.findIndex((id) => id === active.id);
      const newIndex = sprintIds.findIndex((id) => id === over.id);

      if (oldIndex === -1 || newIndex === -1) return prev;

      const [moved] = sprints.splice(oldIndex, 1);
      sprints.splice(newIndex, 0, moved);

      // Reassign order_id
      day.sprints = sprints.map((s, i) => ({
        ...s,
        order_id: i + 1,
      }));

      return newWeeksData;
    });
  };

  // utils/getWeekTotalDistance.js

  function getWeekTotalDistance(week) {
    if (!week?.days?.length) return 0;

    let total = 0;

    for (const day of week.days) {
      for (const sprint of day.sprints || []) {
        if (sprint.type !== "Sprint") continue;
        const sets = parseInt(sprint.sets) || 0;
        const reps = parseInt(sprint.reps) || 0;
        const distance = parseInt(sprint.distance) || 0;
        total += sets * reps * distance;
      }
    }

    return total;
  }

  /*const calculateTargetTime = (sprint, goalTime) => {
  if (!goalTime || !sprint.pace || !sprint.intensity || !sprint.distance) return '';

  const pace = parseFloat(sprint.pace);
  const intensity = parseFloat(sprint.intensity);
  const distance = parseFloat(sprint.distance);

  if (pace === 0 || intensity === 0) return '';

  const targetTime = (goalTime / (pace / 100) / intensity) / 100 * distance;

  return targetTime.toFixed(2); // 2 decimal places
};*/

  const calculateTargetTime = (sprint, athlete) => {
    if (!sprint.pace || !sprint.intensity || !sprint.distance) return "";

    const pace = parseFloat(sprint.pace);
    const intensity = parseFloat(sprint.intensity);
    const distance = parseFloat(sprint.distance);

    if (pace === 0 || intensity === 0) return "";

    let goalTime = 0;

    if (pace === 100) goalTime = parseFloat(athlete.pr_100m) || 0;
    else if (pace === 200) goalTime = parseFloat(athlete.pr_200m) || 0;
    else if (pace === 400) goalTime = parseFloat(athlete.pr_400m) || 0;
    else return "";

    if (goalTime === 0) return "";

    const rawTime = (goalTime * (distance / pace)) / (intensity / 100);

    return formatOneDecimalTruncate(rawTime).toFixed(1);
  };

  const formatOneDecimalTruncate = (num) => {
    if (isNaN(num)) return "";
    return Math.floor(num * 10) / 10;
  };

  return (
    <div className="flex md:h-screen">
      <StaffSideMenu />
      <div className="max-md:w-full md:flex-1 bg-bgBase md:overflow-auto h-full max-md:pt-4">
        <div className="flex flex-col shadow md:sticky md:top-0 z-30">
          {/* Top Header */}
          <div className="relative flex flex-col -mb-4">
            {athlete && (
              <AthleteProfileCard
                athlete={athlete}
                onSaveSuccess={fetchAthleteData}
              />
            )}
          </div>

          <AthleteTabMenu active="speed-workout" />
        </div>

        <div className="py-10 px-5 md:px-8 xl:px-16 overflow-auto">
          <div className="w-full max-w-[1336px]">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:bg-white md:border md:border-tblBorder rounded-14 md:p-4 xl:p-6">
              {/* Filter + Add Week */}
              <div className="lg:col-span-4 2xl:col-span-3">
                <div className="bg-white border border-tblBorder rounded-14 p-4 xl:p-6 space-y-4 md:space-y-6">
                  <div className="space-y-2 pb-5 border-b border-tblBorder">
                    <label className="block text-slate100 font-inter text-xs font-normal uppercase">
                      Filter by Month:
                    </label>
                    <input
                      type="month"
                      value={selectedMonth}
                      onChange={handleMonthChange}
                      className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                    />
                  </div>
                  {/* add week */}

                  <button
                    onClick={handleAddWeek}
                    className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black capitalize flex items-center justify-center gap-2"
                  >
                    <MdAdd color="#fff" />
                    add week
                  </button>

                  {/* Week Modal */}
                  {showDatePicker && (
                    <div className="space-y-2 admindate">
                      <label className="block text-slate100 font-inter text-xs font-normal uppercase">
                        Select Start Date of New Week (Sunday):
                      </label>
                      <input
                        type="date"
                        value={newWeekStartDate}
                        onChange={(e) => setNewWeekStartDate(e.target.value)}
                        onClick={(e) =>
                          e.target.showPicker && e.target.showPicker()
                        }
                        className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                      />
                      <div className="flex gap-3">
                        <button
                          onClick={handleSaveNewWeek}
                          className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex items-center justify-center gap-3"
                        >
                          Save
                        </button>
                        <button
                          onClick={handleCloseWeek}
                          className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black capitalize flex items-center justify-center gap-2"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                  {/* Template Save Button */}
                  {/* <div className="pt-4 border-t border-tblBorder">
                    <button
                      onClick={handleSaveTemplate}
                      className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                    >
                      Save Template
                    </button>
                  </div> */}
                </div>
              </div>
              <div className="lg:col-span-8 2xl:col-span-9">
                <div className="bg-white border border-tblBorder rounded-14 font-inter">
                  {successMessage && (
                    <div className="my-3 p-4 text-sm font-normal text-green-800 bg-green-100 border border-green-300 rounded">
                      {successMessage}
                    </div>
                  )}

                  {filteredWeeks.length > 0 ? (
                    <div className="border-b border-tblBorder p-4 xl:p-6">
                      <div className="flex flex-wrap gap-2 mb-6">
                        {/*filteredWeeks.map((week, idx) => (
                            <div key={idx} className="flex items-center gap-1">
                                  <button
                                    key={idx}
                                    onClick={() => setActiveWeekTab(idx)}
                                    className={`px-3 py-1 text-sm rounded-t border-b-2 ${
                                      activeWeekTab === idx
                                        ? "border-blue-600 text-blue-700 font-semibold"
                                        : "border-transparent text-slate100 hover:text-blue-600"
                                    }`}
                                  >
                                    {`Week of ${getFormattedDate(week.startDate)}`}
                                  </button>
                                  <button
                                  onClick={() => handleDeleteWeek(week.startDate)}
                                  className="text-red-500 hover:text-red-700 text-sm"
                                  title="Delete Week"
                                >
                                  🗑️
                                </button>
                          </div>
                          ))*/}

                        {filteredWeeks.map((week, idx) => {
                          const totalDistance = getWeekTotalDistance(week);

                          return (
                            <div key={idx} className="flex items-center gap-1">
                              <button
                                onClick={() => setActiveWeekTab(idx)}
                                className={`px-3 py-1 font-inter text-sm rounded-t border-b-2 ${
                                  activeWeekTab === idx
                                    ? "border-darkYellow text-darkYellow font-semibold"
                                    : "border-transparent text-slate100 hover:text-darkYellow"
                                }`}
                              >
                                {`Week of ${getFormattedDate(week.startDate)}`}
                                {totalDistance > 0 && (
                                  <span className="ml-1 font-inter font-normal text-xs text-slate100">
                                    ({totalDistance} m)
                                  </span>
                                )}
                              </button>
                              <button
                                onClick={() => handleDeleteWeek(week.startDate)}
                                className="bg-white py-1 px-2 rounded-sm hover:bg-gray-200"
                                title="Delete Week"
                              >
                                <RiDeleteBin4Line color="#666" size={18} />
                              </button>
                            </div>
                          );
                        })}
                      </div>

                      {/* Days for Active Week */}
                      {filteredWeeks[activeWeekTab] && (
                        <div className="flex gap-2 overflow-auto show-scrollbar">
                          {filteredWeeks[activeWeekTab].days.map(
                            (day, dayIdx) => {
                              const isSelected =
                                selectedDayInfo &&
                                selectedDayInfo.weekIdx ===
                                  weeks.indexOf(filteredWeeks[activeWeekTab]) &&
                                selectedDayInfo.dayIdx === dayIdx;

                              // Calculate total distance for the day
                              let dayDistance = 0;
                              day.sprints?.forEach((sprint) => {
                                if (sprint.type !== "Sprint") return;
                                const sets = parseInt(sprint.sets) || 0;
                                const reps = parseInt(sprint.reps) || 0;
                                const distance = parseInt(sprint.distance) || 0;
                                dayDistance += sets * reps * distance;
                              });

                              return (
                                <button
                                  key={dayIdx}
                                  onClick={() =>
                                    handleDaySelect(
                                      weeks.indexOf(
                                        filteredWeeks[activeWeekTab],
                                      ),
                                      dayIdx,
                                    )
                                  }
                                  className={`px-2 py-1 rounded shadow-sm font-inter font-medium text-xs text-center border ${
                                    isSelected
                                      ? "bg-dark text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  } flex flex-col items-start`}
                                >
                                  {day.label}
                                  <br />
                                  <span className="text-[12px]">
                                    {(() => {
                                      const [y, m, d] = day.date
                                        .split("-")
                                        .map(Number);
                                      return new Date(
                                        y,
                                        m - 1,
                                        d,
                                      ).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                      });
                                    })()}
                                  </span>
                                  {dayDistance > 0 && (
                                    <div
                                      className={`text-[10px] mt-1 ${
                                        isSelected
                                          ? "text-white font-semibold"
                                          : "text-slate100"
                                      }`}
                                    >
                                      ({dayDistance} m)
                                    </div>
                                  )}
                                </button>
                              );
                            },
                          )}
                        </div>
                      )}
                    </div>
                  ) : weeks.length > 0 ? (
                    <div className="p-4 xl:p-6 text-sm text-slate100 italic mt-4">
                      No weeks found for this month.
                    </div>
                  ) : null}

                  {/* Workout Builder Placeholder */}
                  {selectedDayInfo && (
                    <>
                      <div className="p-4 md:p-6 border-b border-tblBorder">
                        <h3 className="font-inter text-lg md:text-xl font-medium text-dark">
                          Workout for {getFormattedDate(selectedDayInfo.date)}
                        </h3>
                      </div>
                      <div className="font-inter">
                        {selectedDay.sprints &&
                        selectedDay.sprints.length > 0 ? (
                          reorderMode ? (
                            <div className="space-y-4 px-4 md:px-6 pt-5">
                              <h3 className="font-inter text-lg font-medium text-dark">
                                Reorder Sprints
                              </h3>
                              <button
                                onClick={() => setReorderMode(!reorderMode)}
                                className={`${
                                  reorderMode ? "bg-dark" : ""
                                } w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black`}
                              >
                                {reorderMode
                                  ? "Back to Editor"
                                  : "Reorder Sprints"}
                              </button>

                              <DndContext
                                onDragEnd={(event) =>
                                  handleSprintDragEnd(
                                    event,
                                    selectedDayInfo.weekIdx,
                                    selectedDayInfo.dayIdx,
                                  )
                                }
                              >
                                {selectedDay.sprints.map((sprint, index) => {
                                  const sprintId =
                                    sprint._id || `temp-${index}`;

                                  return (
                                    <DroppableSprint
                                      key={sprintId}
                                      id={sprintId}
                                    >
                                      <DraggableSprintItem
                                        key={sprintId}
                                        id={sprintId}
                                        sprintIndex={index}
                                        sprint={sprint}
                                      />
                                    </DroppableSprint>
                                  );
                                })}
                              </DndContext>
                            </div>
                          ) : (
                            <>
                              {/* Buttons only shown if sprint data exists */}
                              <div className="flex flex-col font-inter gap-6 border-b border-tblBorder p-4 md:p-6 mb-4 md:mb-6">
                                <div className="flex max-lg:flex-col justify-between items-start gap-3 lg:gap-5">
                                  <h2 className="text-base font-medium">
                                    Sprint Configurations
                                  </h2>
                                  {/* Display training focus and training phase */}
                                  <div className="flex flex-wrap gap-5">
                                    <div>
                                      <h3 className="text-dark font-medium">
                                        Training Focus:
                                      </h3>
                                      <p className="text-sm font-normal text-slate100">
                                        {selectedDay.training_focus ||
                                          "No focus set"}
                                      </p>
                                    </div>
                                    <div>
                                      <h3 className="text-dark font-medium">
                                        Training Phase:
                                      </h3>
                                      <p className="text-sm font-normal text-slate100">
                                        {selectedDay.training_phase ||
                                          "No phase set"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 lg:gap-4">
                                  {/* Left: Total Distance */}
                                  {selectedDay.sprints?.length > 0 && (
                                    <p className="font-semibold text-sm text-slate100">
                                      Total:{" "}
                                      {selectedDay.sprints.reduce(
                                        (total, sprint) => {
                                          if (sprint.type === "Rest")
                                            return total;
                                          const sets =
                                            parseFloat(sprint.sets) || 0;
                                          const reps =
                                            parseFloat(sprint.reps) || 0;
                                          const distance =
                                            parseFloat(sprint.distance) || 0;
                                          return total + sets * reps * distance;
                                        },
                                        0,
                                      )}{" "}
                                      meters
                                    </p>
                                  )}

                                  {/* Right: Action Buttons */}
                                  <div className="flex flex-wrap items-start lg:justify-end gap-2">
                                    <button
                                      onClick={() => addSprintRow()}
                                      className="pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-normal text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                                    >
                                      <MdAdd color="#000" size={18} /> Add
                                      Sprint
                                    </button>

                                    {showRestInput ? (
                                      <div className="flex flex-col gap-2">
                                        <input
                                          type="text"
                                          placeholder="Enter rest notes"
                                          value={restNoteInput}
                                          onChange={(e) =>
                                            setRestNoteInput(e.target.value)
                                          }
                                          className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                        />
                                        <button
                                          onClick={() => {
                                            addRestRow(restNoteInput);
                                            setRestNoteInput("");
                                            setShowRestInput(false);
                                          }}
                                          className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                        >
                                          Save
                                        </button>
                                        <button
                                          onClick={() => {
                                            setRestNoteInput("");
                                            setShowRestInput(false);
                                          }}
                                          className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    ) : (
                                      <button
                                        onClick={() => setShowRestInput(true)}
                                        className="pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-normal text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                                      >
                                        <MdAdd color="#000" size={18} /> Add
                                        Rest
                                      </button>
                                    )}

                                    <button
                                      onClick={() =>
                                        setReorderMode(!reorderMode)
                                      }
                                      className={`${
                                        reorderMode
                                          ? "bg-gray-700"
                                          : "bg-slate100"
                                      } pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-normal text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200`}
                                    >
                                      <DotedSvg />{" "}
                                      {reorderMode
                                        ? "Back to Editor"
                                        : "Reorder"}
                                    </button>

                                    <button
                                      onClick={handleSaveTemplate}
                                      className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black inline-flex items-center gap-2"
                                    >
                                      <SaveTempIcon /> Save Template
                                    </button>
                                  </div>
                                </div>
                              </div>

                              {/* Render Sprint and Rest Rows */}
                              {selectedDay.sprints.map((sprint, index) => {
                                const selectedExercise = exerciseOptions.find(
                                  (exercise) =>
                                    exercise._id ===
                                    (sprint.exercise_id &&
                                    typeof sprint.exercise_id === "object"
                                      ? sprint.exercise_id._id
                                      : sprint.exercise_id),
                                );

                                const extractYouTubeId = (url) => {
                                  if (!url) return null;

                                  const regex =
                                    /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:shorts\/|watch\?.*v=|embed\/|v\/|.*[?&]v=))([\w-]{11})/;

                                  const match = url.match(regex);
                                  return match ? match[1] : null;
                                };

                                const extractYouTubeThumbnail = (url) => {
                                  const id = extractYouTubeId(url);
                                  return id
                                    ? `https://img.youtube.com/vi/${id}/hqdefault.jpg`
                                    : null;
                                };

                                const thumbnail = selectedExercise?.video_url
                                  ? extractYouTubeThumbnail(
                                      selectedExercise.video_url,
                                    )
                                  : null;

                                return (
                                  <>
                                    {sprint.type === "Rest" ? (
                                      <div
                                        key={sprint._id}
                                        className="px-4 md:px-6 py-2 md:py-4"
                                      >
                                        <div className="bg-tblHead border border-tblBorder rounded-10 font-inter flex justify-between gap-5 p-4 mb-2">
                                          <div>
                                            <div className="text-sm text-slate100">
                                              <label className="font-semibold">
                                                Rest Notes:
                                              </label>{" "}
                                              <span className="font-normal">
                                                {sprint.rest_notes || "None"}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flex-none -mt-1">
                                            <button
                                              onClick={() =>
                                                deleteSprintRow(index)
                                              }
                                              className="p-2 rounded hover:bg-gray-200"
                                            >
                                              <RiDeleteBin4Line
                                                color="#666666"
                                                size={18}
                                              />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        key={sprint._id}
                                        className="px-4 md:px-6 py-2 md:py-4"
                                      >
                                        <div className="flex flex-col bg-tblHead border border-tblBorder rounded-10 mb-2">
                                             {/* Exercise Dropdown - Delete and Ope-Close Icon */}
                                              {openSprintId === sprint._id && (
                                                <div className={`${openSprintId === sprint._id ? "border-b" : ""}  border-tblBorder`}>
                                                  <div className="p-4 w-full flex gap-3">
                                                    <SingleSelectExerciseList
                                                      value={
                                                        sprint.exercise_id
                                                          ? typeof sprint.exercise_id ===
                                                            "object"
                                                            ? sprint.exercise_id._id
                                                            : sprint.exercise_id
                                                          : null
                                                      }
                                                      onChange={(val) =>
                                                        handleSprintChange(
                                                          index,
                                                          "exercise_id",
                                                          val,
                                                        )
                                                      }
                                                      exercises={exerciseOptions}
                                                      resetTrigger={resetTrigger}
                                                    />
                                                    {/* Delete and Ope-Close Icon */}
                                                    <div className="flex-none flex items-end">
                                                      <button
                                                        onClick={() =>
                                                          deleteSprintRow(index)
                                                        }
                                                        className="rounded hover:bg-white p-2"
                                                      >
                                                        <RiDeleteBin4Line
                                                          color="#666666"
                                                          size={18}
                                                        />
                                                      </button>

                                                      <button
                                                        onClick={() =>
                                                          toggleSprint(sprint._id)
                                                        }
                                                        className="rounded hover:bg-white p-2"
                                                      >
                                                        <IoIosArrowDown
                                                          color="#666666"
                                                          size={18}
                                                          className={`${openSprintId === sprint._id ? "rotate-180" : ""} transition-all`}
                                                        />
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            <>
                                              {/* sets and reps and etc... */}
                                              <div className="flex flex-wrap gap-3  py-3 px-4">
                                                <div className="flex-none">
                                                  <div className="w-12 h-12 lg:w-16 lg:h-16 shrink-0">
                                                    {openSprintId ===
                                                      sprint._id ||
                                                      (sprint.exercise_id && (
                                                        <>
                                                          <img
                                                            src={thumbnail}
                                                            alt={
                                                              selectedExercise?.title ||
                                                              "Exercise Thumbnail"
                                                            }
                                                            className="w-12 h-12 object-cover rounded-md border border-tblBorder"
                                                          />
                                                        </>
                                                      ))}
                                                  </div>
                                                </div>
                                                <div className="flex-1 flex flex-wrap items-center gap-2.5">
                                                  {/* Sets */}
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Sets
                                                    </label>
                                                    <select
                                                      value={sprint.sets}
                                                      onChange={(e) =>
                                                        handleSprintChange(
                                                          index,
                                                          "sets",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                    >
                                                      {range(1, 15).map(
                                                        (num) => (
                                                          <option
                                                            key={num}
                                                            value={num}
                                                          >
                                                            {num}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </div>
                                                  {/* Reps */}
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Reps
                                                    </label>
                                                    <select
                                                      value={sprint.reps}
                                                      onChange={(e) =>
                                                        handleSprintChange(
                                                          index,
                                                          "reps",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                    >
                                                      {range(1, 15).map(
                                                        (num) => (
                                                          <option
                                                            key={num}
                                                            value={num}
                                                          >
                                                            {num}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </div>
                                                  {/* Distance */}
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Distance (m)
                                                    </label>
                                                    <select
                                                      value={sprint.distance}
                                                      onChange={(e) =>
                                                        handleSprintChange(
                                                          index,
                                                          "distance",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                    >
                                                      {distances.map((d) => (
                                                        <option
                                                          key={d}
                                                          value={d}
                                                        >
                                                          {d}
                                                        </option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                  {/* Pace */}
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Pace
                                                    </label>
                                                    <select
                                                      value={sprint.pace}
                                                      onChange={(e) =>
                                                        handleSprintChange(
                                                          index,
                                                          "pace",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                    >
                                                      {paces.map((p) => (
                                                        <option
                                                          key={p}
                                                          value={p}
                                                        >
                                                          {p}
                                                        </option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                  {/* Intensity */}
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Intensity (%)
                                                    </label>
                                                    <select
                                                      value={sprint.intensity}
                                                      onChange={(e) =>
                                                        handleSprintChange(
                                                          index,
                                                          "intensity",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                    >
                                                      {intensities.map((i) => (
                                                        <option
                                                          key={i}
                                                          value={i}
                                                        >
                                                          {i}
                                                        </option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                     {/* Target Time */}
                                       
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Target Time (s)
                                                    </label>
                                                    <input
                                                      type="text"
                                                      value={
                                                        sprint.target_time || ""
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                      readOnly
                                                    />
                                                  </div>
                                                  {/* Rest */}
                                                  <div className="flex-1 min-w-20">
                                                    <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                      Rest
                                                    </label>
                                                    <input
                                                      type="text"
                                                      value={sprint.rest}
                                                      onChange={(e) =>
                                                        handleSprintChange(
                                                          index,
                                                          "rest",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal"
                                                      placeholder="Enter rest duration"
                                                    />
                                                  </div>
                                               
                                                </div>
                                                {/* Delete and Ope-Close Icon */}
                                                <div className="flex-none flex items-start lg:items-center">
                                                  {openSprintId ===
                                                  sprint._id ? (
                                                    <div className="opacity-0">
                                                      <button
                                                        onClick={() =>
                                                          deleteSprintRow(index)
                                                        }
                                                        className="rounded hover:bg-white p-2"
                                                      >
                                                        <RiDeleteBin4Line
                                                          color="#666666"
                                                          size={18}
                                                        />
                                                      </button>

                                                      <button
                                                        onClick={() =>
                                                          toggleSprint(
                                                            sprint._id,
                                                          )
                                                        }
                                                        className="rounded hover:bg-white p-2"
                                                      >
                                                        <IoIosArrowDown
                                                          color="#666666"
                                                          size={18}
                                                          className={`${openSprintId === sprint._id ? "rotate-180" : ""} transition-all`}
                                                        />
                                                      </button>
                                                    </div>
                                                  ) : (
                                                    <>
                                                      <button
                                                        onClick={() =>
                                                          deleteSprintRow(index)
                                                        }
                                                        className="rounded hover:bg-white p-2"
                                                      >
                                                        <RiDeleteBin4Line
                                                          color="#666666"
                                                          size={18}
                                                        />
                                                      </button>

                                                      <button
                                                        onClick={() =>
                                                          toggleSprint(
                                                            sprint._id,
                                                          )
                                                        }
                                                        className="rounded hover:bg-white p-2"
                                                      >
                                                        <IoIosArrowDown
                                                          color="#666666"
                                                          size={18}
                                                          className={`${openSprintId === sprint._id ? "rotate-180" : ""} transition-all`}
                                                        />
                                                      </button>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                              {/* Notes and Exercise on same row */}
                                              {openSprintId === sprint._id && 
                                                (
                                              <div className="border-t border-tblBorder">
                                                {/* Notes */}
                                                <div className="w-full p-4">
                                                  <label className="text-slate100 font-inter font-normal text-xs block mb-1">
                                                    Notes
                                                  </label>
                                                  <textarea
                                                    value={sprint.notes || ""}
                                                    onChange={(e) =>
                                                      handleSprintChange(
                                                        index,
                                                        "notes",
                                                        e.target.value,
                                                      )
                                                    }
                                                    placeholder="Add notes about this block..."
                                                    className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-3 text-dark text-sm font-normal"
                                                    rows={4}
                                                  />
                                                </div>
                                                {/* Adding the video uploaded */}
                                                {sprint.video_path && (
                                                  <div className="p-4 border-t border-tblBorder">
                                                    {/* <div className="w-fit p-3 bg-tblHead border border-tblBorder rounded-10"> */}
                                                    <div className="font-inter font-normal text-xs text-slate100 mb-2">
                                                      <span>Athlete Video:</span>
                                                    </div>
  
                                                    <video
                                                      src={sprint.video_path}
                                                      controls
                                                      className="w-full max-w-sm rounded-10"
                                                    />
                                                    {/* </div> */}
                                                  </div>
                                                )}
                                              </div>
                                                )
                                              }

                                            </>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                );
                              })}
                            </>
                          )
                        ) : (
                          <div className="md:flex-1 overflow-auto">
                            <div className="p-4 md:p-6 md:pb-0">
                              <h3 className="font-inter text-lg font-medium text-dark mb-4 md:mb-6">
                                Choose a Training Template
                              </h3>
                              <div className="relative">
                                <input
                                  type="text"
                                  value={searchQuery}
                                  onChange={handleSearch}
                                  placeholder="Search training focus..."
                                  className="w-full bg-white border border-tblBorder !pl-10 py-1.5 px-3 rounded-lg text-dark font-inter font-medium text-base outline-none placeholder:font-inter placeholder:font-normal"
                                  aria-label="Search Training Focus"
                                />
                                <span className="absolute top-1/2 -translate-y-1/2 left-3">
                                  <CiSearch color="#666" size={18} />
                                </span>
                              </div>
                            </div>

                            <div className="md:p-6">
                              <table className="table-auto font-inter w-full show-scrollbar">
                                {/* <thead className="sticky top-0 bg-tblHead">
                                  <tr className="text-slate100 !font-medium text-xs md:text-sm uppercase">
                                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                                      Training Focus
                                    </th>
                                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                                      Training Phase
                                    </th>
                                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                                      Total Distance
                                    </th>
                                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                                      Actions
                                    </th>
                                  </tr>
                                </thead> */}
                                <tbody>
                                  {filteredTrainingFocuses
                                    .slice(
                                      (currentPage - 1) * itemsPerPage,
                                      currentPage * itemsPerPage,
                                    )
                                    .map((item, index) => (
                                      <React.Fragment key={item._id}>
                                        <tr
                                          onClick={() =>
                                            setExpandedId(
                                              expandedId === item._id
                                                ? null
                                                : item._id,
                                            )
                                          }
                                          className={`cursor-pointer hover:bg-[#F9FAFB] transition `}
                                        >
                                          <td className="p-4 whitespace-nowrap">
                                            <div className="flex flex-nowrap justify-between gap-x-5 gap-y-2">
                                              <div>
                                                <span className="block text-dark font-medium max-[430px]:text-xs text-sm whitespace-pre-wrap">
                                                  {" "}
                                                  {item.training_focus}
                                                </span>
                                                <span className="block text-slate100 font-medium max-[430px]:text-xs text-xs whitespace-pre-wrap">
                                                  {" "}
                                                  {item.training_phase}
                                                </span>
                                              </div>

                                              <div className="flex-none flex items-center gap-2">
                                                {item.sprints?.length > 0 && (
                                                  <span className="text-slate100 font-medium text-xs md:text-sm">
                                                    {item.sprints.reduce(
                                                      (total, sprint) => {
                                                        if (
                                                          sprint.type === "Rest"
                                                        )
                                                          return total;

                                                        const sets =
                                                          parseFloat(
                                                            sprint.sets,
                                                          ) || 0;
                                                        const reps =
                                                          parseFloat(
                                                            sprint.reps,
                                                          ) || 0;
                                                        const distance =
                                                          parseFloat(
                                                            sprint.distance,
                                                          ) || 0;

                                                        return (
                                                          total +
                                                          sets * reps * distance
                                                        );
                                                      },
                                                      0,
                                                    )}{" "}
                                                    meters
                                                  </span>
                                                )}

                                                <button className="rounded hover:bg-white p-1 md:p-2">
                                                  <IoIosArrowDown
                                                    color="#666666"
                                                    size={18}
                                                    className={`${expandedId === item._id ? "rotate-180" : ""} transition-all`}
                                                  />
                                                </button>
                                              </div>
                                            </div>
                                          </td>
                                          {/* <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap text-left space-x-2">
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation(); 
                                                setFocusToApply(item);
                                                setShowConfirmModal(true);
                                              }}
                                              className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                            >
                                              Use This
                                            </button>
                                          </td> */}
                                        </tr>

                                        {expandedId === item._id && (
                                          <tr>
                                            <td>
                                              <div className="py-3 px-4 w-full overflow-auto">
                                                <div className="bg-[#F2F2F2] rounded-10 p-4">
                                                  {item.sprints?.length > 0 ? (
                                                    <div className="space-y-4">
                                                      {item.sprints.map(
                                                        (
                                                          sprint,
                                                          sprintIndex,
                                                        ) =>
                                                          sprint.type ===
                                                          "Rest" ? (
                                                            <div
                                                              key={`rest-${sprintIndex}`}
                                                              className="w-full bg-yellow-100 text-gray-800 italic px-4 py-3 border-l-4 border-yellow-500 rounded"
                                                            >
                                                              💤{" "}
                                                              <strong>
                                                                Rest Segment:
                                                              </strong>{" "}
                                                              {sprint.rest_notes ||
                                                                "No notes"}
                                                            </div>
                                                          ) : (
                                                            <>
                                                              <div
                                                                key={`sprint-${sprintIndex}`}
                                                                className=""
                                                              >
                                                                <div className="space-y-3">
                                                                  <div className="border border-tblBorder rounded-10 p-4 bg-white shadow-sm text-dark font-inter font-medium text-sm space-y-2">
                                                                    <div className="flex flex-wrap gap-6">
                                                                      <div>
                                                                        <span className="text-slate100 font-inter font-normal text-xs">
                                                                          Sets:
                                                                        </span>{" "}
                                                                        {
                                                                          sprint.sets
                                                                        }
                                                                      </div>
                                                                      <div>
                                                                        <span className="text-slate100 font-inter font-normal text-xs">
                                                                          Reps:
                                                                        </span>{" "}
                                                                        {
                                                                          sprint.reps
                                                                        }
                                                                      </div>
                                                                      <div>
                                                                        <span className="text-slate100 font-inter font-normal text-xs">
                                                                          Distance:
                                                                        </span>{" "}
                                                                        {
                                                                          sprint.distance
                                                                        }{" "}
                                                                        m
                                                                      </div>
                                                                      <div>
                                                                        <span className="text-slate100 font-inter font-normal text-xs">
                                                                          Pace:
                                                                        </span>{" "}
                                                                        {
                                                                          sprint.pace
                                                                        }
                                                                      </div>
                                                                      <div>
                                                                        <span className="text-slate100 font-inter font-normal text-xs">
                                                                          Intensity:
                                                                        </span>{" "}
                                                                        {
                                                                          sprint.intensity
                                                                        }
                                                                      </div>
                                                                      <div>
                                                                        <span className="text-slate100 font-inter font-normal text-xs">
                                                                          Rest:
                                                                        </span>{" "}
                                                                        {
                                                                          sprint.rest
                                                                        }
                                                                      </div>
                                                                    </div>
                                                                    <div className="pt-2 border-t border-tblBorder">
                                                                      <span className="text-slate100 font-inter font-normal text-xs">
                                                                        Exercise:
                                                                      </span>{" "}
                                                                      {sprint
                                                                        .exercise_id
                                                                        ?.title ||
                                                                        "None"}
                                                                    </div>
                                                                  </div>

                                                                  <div className="bg-[#E1E1E1] rounded-10 p-2.5">
                                                                    <div className="text-dark text-sm font-normal">
                                                                      <span>
                                                                        Notes:
                                                                      </span>{" "}
                                                                      {sprint.notes ||
                                                                        "-"}
                                                                    </div>
                                                                  </div>
                                                                  <button
                                                                    onClick={(
                                                                      e,
                                                                    ) => {
                                                                      e.stopPropagation(); // Prevent expanding row
                                                                      setFocusToApply(
                                                                        item,
                                                                      );
                                                                      setShowConfirmModal(
                                                                        true,
                                                                      );
                                                                    }}
                                                                    className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex justify-center items-center gap-2"
                                                                  >
                                                                    Use Template{" "}
                                                                    <FaChevronRight color="FFF" />
                                                                  </button>
                                                                </div>
                                                              </div>
                                                            </>
                                                          ),
                                                      )}
                                                    </div>
                                                  ) : (
                                                    <p className="font-inter text-sm text-slate100 italic">
                                                      No sprint data found.
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ))}
                                </tbody>
                              </table>
                            </div>

                            {/* Pagination Controls */}
                            <div className="flex max-sm:flex-col justify-between items-center md:p-6 mt-4">
                              <button
                                disabled={currentPage === 1}
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                                className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                                  currentPage === 1
                                    ? "cursor-not-allowed"
                                    : "text-black"
                                }`}
                              >
                                <MdKeyboardArrowLeft size={20} /> Previous
                              </button>
                              <span className="text-dark font-inter font-normal text-sm">
                                Page {currentPage} of {totalPages}
                              </span>
                              <button
                                disabled={currentPage === totalPages}
                                onClick={() =>
                                  handlePageChange(currentPage + 1)
                                }
                                className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                                  currentPage === totalPages
                                    ? "cursor-not-allowed"
                                    : "text-black"
                                }`}
                              >
                                Next <MdKeyboardArrowRight size={20} />
                              </button>
                            </div>
                          </div>
                        )}

                        {/*modal for Use a training focus */}
                        {showConfirmModal && (
                          <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50">
                            <div className="bg-white rounded-10 font-inter w-full max-w-md">
                              <div className="p-4 md:p-6 border-b border-tblBorder">
                                <h2 className="text-xl font-medium">
                                  Confirm Action
                                </h2>
                              </div>
                              <div className="p-4 md:p-6">
                                <p className="font-normal text-sm">
                                  Do you want to copy this training focus into{" "}
                                  <strong>
                                    {" "}
                                    {getFormattedDate(selectedDayInfo.date)}
                                  </strong>
                                  ?
                                </p>
                              </div>
                              <div className="flex justify-end gap-2 p-4 md:p-6 border-t border-tblBorder">
                                <button
                                  onClick={() => setShowConfirmModal(false)}
                                  className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={() => {
                                    applyFocusToDay(focusToApply);
                                    setShowConfirmModal(false);
                                  }}
                                  className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                                >
                                  Yes, Copy
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DraggableSprintItem = ({ sprintIndex, id, sprint }) => {
  const navigate = useNavigate();
  const [dragMode, setDragMode] = useState(true);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none", // Smooth transition when not dragging
      }
    : undefined;

  return (
    <>
      <div
        ref={setNodeRef}
        {...attributes}
        {...(dragMode ? listeners : {})} // Apply listeners when dragMode is true  // Apply listeners only when dragMode is true
        style={style}
      >
        <div
          key={sprintIndex}
          className="border border-tblBorder rounded-10 bg-white shadow-sm"
        >
          {sprint.type === "Rest" ? (
            <div className="font-inter font-normal text-sm">
              <p>
                <strong>Rest:</strong> {sprint.rest_notes || "None"}
              </p>
            </div>
          ) : (
            <>
              <div className="flex flex-wrap gap-2.5 p-3">
                <div className="flex-1">
                  <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                    Sets:
                  </span>
                  <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                    {sprint.sets}
                  </p>
                </div>
                <div className="flex-1">
                  <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                    Reps:
                  </span>
                  <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                    {sprint.reps}
                  </p>
                </div>
                <div className="flex-1">
                  <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                    Distance:
                  </span>
                  <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                    {sprint.distance}m
                  </p>
                </div>
                <div className="flex-1">
                  <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                    Pace:
                  </span>
                  <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                    {sprint.pace}
                  </p>
                </div>
                <div className="flex-1">
                  <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                    Intensity:
                  </span>
                  <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                    {sprint.intensity}%
                  </p>
                </div>
                <div className="flex-1">
                  <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                    Rest:
                  </span>
                  <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                    {sprint.rest}
                  </p>
                </div>
              </div>
              <div className="w-full p-4 border-t border-tblBorder">
                <span className="text-slate100 font-inter font-normal text-xs block mb-1">
                  Notes:
                </span>
                <p className="w-full bg-white border border-tblBorder rounded-lg outline-none py-1.5 px-2 text-dark text-sm font-normal">
                  {sprint.notes}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const DroppableSprint = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } p-4 rounded-md`}
    >
      {children}
    </div>
  );
};
